import { useRef, useState, useCallback } from 'react';
import { getOrCreateOrigin, positionOriginAtElement } from '../../helpers/uiHelpers';
import { getClosestTableElement } from '../../helpers/tableHelpers';

export default function useTableContextMenu() {
  const anchorRef = useRef(null);
  const positionRef = useRef({ x: 0, y: 0 });
  const [isOpen, setIsOpen] = useState(false);

  const openAtElement = useCallback((el) => {
    if (!el) return;
    anchorRef.current = el;
    try {
      const origin = getOrCreateOrigin({ className: 'context-origin' });
      positionOriginAtElement(origin, el);
    } catch (e) {}
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    anchorRef.current = null;
  }, []);

  const onContextMenu = useCallback((e) => {
    const el = getClosestTableElement(e.target);
    if (!el) {
      close();
      return;
    }
    try {
      e.preventDefault();
      e.stopPropagation();
    } catch (err) {}
    openAtElement(el);
  }, [openAtElement, close]);

  return {
    anchorRef,
    positionRef,
    isOpen,
    openAtElement,
    close,
    onContextMenu,
  };
}
